import Vue from 'vue'
import AscTooltip from '@/components/atoms/AscTooltip'

export default Vue.extend({
  components: {
    AscTooltip,
  },

  data: function () {
    return {
      disabled: false,
    }
  },

  beforeMount() {
    if (this.params.disabled) {
      this.disabled = this.params.disabled
    }
  },

  methods: {
    handleDelete() {
      this.params.handleDelete(this.params.value)
    },
  },

  template: `<div style="display: flex;">
      <asc-tooltip tooltip="Delete" left>
        <button type="button" @click="handleDelete()" class="v-icon notranslate v-icon--link mdi mdi-delete theme--light" style="font-size: 16px; color: rgb(0, 0, 0); caret-color: rgb(0, 0, 0); justify-content: center; width: 100%;"></button>
      </asc-tooltip>
    </div>`,
})
